import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  aboutTitle = 'About Me';
  aboutParagraphs: string[];

  constructor() { }

  ngOnInit(): void {
    this.updateAboutParagraphs();
  }

  updateAboutParagraphs(): void {
    const experienceDuration = this.calculateExperienceDuration();
    this.aboutParagraphs = [
      `In <span class='underline'>${experienceDuration} years of experience</span>, I have embraced multiple roles: <span class='underline'>Full-stack Developer</span>, <span class='underline'>Data Analyst</span>, and <span class='underline'>Technical Contributor</span>. I love using my knowledge to create innovative solutions that solve problems.`,
      "I am passionate about leveraging my expertise to develop solutions that address real-world challenges.",
      "My skills include creating responsive user interfaces, developing APIs, managing databases, and ensuring efficient data handling. I excel in optimizing systems, standardizing patterns, and suggesting and implementing ideas that add value to every project I work on.",
      "In my spare time, I enjoy programming for personal projects, both as a hobby and for practical utility."
    ];
  }

  calculateExperienceDuration(): string {
    const startDate = new Date(2021, 7); // August 2021
    const currentDate = new Date();

    const startYear = startDate.getFullYear();
    const startMonth = startDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    let years = currentYear - startYear;
    let months = currentMonth - startMonth;

    if (months < 0) {
      years--;
      months += 12;
    }

    const totalYears = years + months / 12;
    return totalYears.toFixed(1);
  }
}
